<template>
  <section
    :class="{
      'breakout-section': true,
    }"
  >
    <div
      :class="{
        'container px-0': true,
      }"
    >
      <div
        :class="{
          'my-10 px-12 pb-14 pt-11': true,
          'border border-www-color-primary-lighter bg-www-color-white': backgroundColor === 'light',
          'dark-bg bg-www-color-neutral-medium-dark': backgroundColor === 'dark',
        }"
      >
        <PortableText
          v-if="breakoutSectionContent"
          :portable-data="breakoutSectionContent"
          :class="{
            'text-www-color-neutral-medium-dark': backgroundColor === 'light',
            'text-www-color-white': backgroundColor === 'dark',
          }"
        />
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
import PortableText from '~/components/Atoms/PortableText/PortableText.vue';
import type { BreakoutSection } from '~/sanity/types';
defineProps<BreakoutSection>();
</script>

<style lang="scss">
.breakout-section {
  .dark-bg {
    .portable-text-link {
      color: var(--www-color-accent-orange-light) !important;
      &:hover {
        color: var(--www-color-accent-orange-light) !important;
      }
    }
  }
}
</style>
